
const digest = 'c8b4b7e6c415e2b9cadd95aa3c245ad5e2ac78483019140db3fdbd6553367936';
const classes = {"wrapper":"_wrapper_3uktw_1"};
const css = `._wrapper_3uktw_1 {
  display: flex;
  flex-direction: row;
  gap: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  